import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import PageHeaderText from 'components/base/page-header-text';
import EditKitchenDetails from './edit-kitchen-details';
import PreviewKitchenDetails from './preview-kitchen-details';
import PageText from 'components/base/page-text';
import useDashboardContext from 'contexts/dashboard.context';
import { ROUTE_KEYS, ROUTE_PREFIX } from 'utils/constants';
import { Breadcrumbs } from '@cokitchen/cokitchen-components';

const CokitchenDetailsPage = () => {
  const { activeCokitchen } = useDashboardContext();
  const [editing, setEditing] = useState(
    new URLSearchParams(useLocation().search).get('edit') === 'true'
  );

  const breadCrumbs = [
    { name: 'Overview', path: `${ROUTE_PREFIX.FOOD}/${ROUTE_KEYS.OVERVIEW}` },
    {
      name: `${activeCokitchen?.name ?? '...'}`,
      path: ''
    }
  ];
  const kitchenLoading = false;
  return (
    <div className='pb-10'>
      <Breadcrumbs breadcrumbs={breadCrumbs} />
      <PageHeaderText
        title={activeCokitchen?.name ?? 'Kitchen'}
        description={`Update ${activeCokitchen?.name ?? 'Kitchen'} details here`}>
        {!editing && (
          <button
            className='border border-[#E7E8E9] shadow text-[#5C5F64] w-[86px] h-[40px] py-2 rounded-[8px]'
            onClick={() => {
              setEditing(true);
            }}>
            Edit
          </button>
        )}
      </PageHeaderText>

      {kitchenLoading ? (
        <PageText text='Loading' />
      ) : editing ? (
        <EditKitchenDetails onCancel={() => setEditing(false)} />
      ) : (
        <PreviewKitchenDetails />
      )}
    </div>
  );
};

export default CokitchenDetailsPage;
